import { render, staticRenderFns } from "./CompanyItem.vue?vue&type=template&id=0e741d7f&scoped=true&lang=pug"
import script from "./CompanyItem.vue?vue&type=script&lang=js"
export * from "./CompanyItem.vue?vue&type=script&lang=js"
import style0 from "./CompanyItem.vue?vue&type=style&index=0&id=0e741d7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e741d7f",
  null
  
)

export default component.exports